<div class="main-container">
<div class="navigation-breadcrumb">
  <span class="breadcrumb-text"  (click)="navigateToOpsVendorDashboard()">
    {{ OPSAdminPageBreadcrumb.OPSAccessManagement }}
  </span>
</div>
<div class="access-control-container">
  <div class="page-title">{{ pageTitle }}</div>
  <div class="search-bar-container">
    <div class="search-child">
      <emerald-input [label]="'Search'" [trailingIcon]="'search'" (keyup)="searchVendorPOCs($event)"
        [value]="filterValue"><emerald-icon *ngIf="filterValue?.length" [icon]="'close'"
          (click)="clearSearch()"></emerald-icon>
      </emerald-input>
    </div>
    <emerald-button label="Add New" (onClick)="openAddVendorPocModal()"></emerald-button>
  </div>
  <!-- Emerald Datatable  with Empty State Handling -->
  <ng-container *ngIf="filteredVendorData?.length; else noDataTemplate">
    <emerald-datatable [columnDefs]="columnDefs" [rowData]="filteredVendorData" [paginationParams]="paginationParams"
      [customCellTemplate]="{ status: statusToggleTemplate }" [maxHeight]="maxTableHeight"
      (onPageChange)="onPageChange($event)">
    </emerald-datatable>
  </ng-container>

  <ng-template #noDataTemplate>
    <section class="records-container" aria-label="Records section">
      <div class="empty-state">
        <ng-container *ngIf="filteredVendorData?.length === 0">
          <h2 class="empty-state-title">{{ errorMsg }}</h2>
        </ng-container>
        <img [src]="imageSrc" alt="No records illustration" class="empty-state-image" />
      </div>
    </section>
  </ng-template>

  <!-- Custom Status Column Template -->
  <ng-template #statusToggleTemplate let-level="level" let-eachRow="eachRow">
    <div class="status-toggle-container">
      <emerald-switch [selected]="eachRow.status && eachRow.status.toLowerCase() === 'active'" (onChange)="onStatusToggle(eachRow)"></emerald-switch>
      <span class="status-label">{{ eachRow.status && eachRow.status.toLowerCase() === 'active' ? 'Active' : 'InActive' }}</span>
    </div>
  </ng-template>
</div>
<!-- Modal for Add Vendor POC -->
<emerald-modal [opened]="addVendorPocModalOpen" (close)="closeAddVendorPocModal()">
  <ng-container *ngIf="addVendorPocModalOpen">
    <app-add-vendor-poc
      #addVendorPocComp
      [vendorData]="filteredVendorData"
      (cancel)="closeAddVendorPocModal()"
      (submit)="onSubmit($event)"></app-add-vendor-poc>
  </ng-container>
</emerald-modal>
<!-- Confirmation Modal -->
<div class="custom-confirmation-dialog">
  <emerald-modal [opened]="confirmationModal.open" (close)="closeConfirmationModal()">
    <div class="confirmation-dialog">
      <h2 class="dialog-title">{{ confirmationModal.title }}</h2>
      <p class="dialog-message">{{ confirmationModal.message }}</p>
      <div *ngIf="confirmationModal.error" class="error-message">{{ confirmationModal.error }}</div>
      <div class="dialog-actions">
        <emerald-button label="Cancel" type="Secondary" (onClick)="closeConfirmationModal()"></emerald-button>
        <emerald-button [label]="confirmationModal.confirmLabel" type="Primary"
          (onClick)="confirmStatusChange()"></emerald-button>
      </div>
    </div>
  </emerald-modal>
</div>
</div>

